export const getHttpCitiesFilter = (cities) => {
  let httpFilters = '';
  cities.forEach(city => {
    httpFilters += 'city_id=' + city + '&';
  });

  httpFilters = httpFilters.slice(0, -1);

  return httpFilters;
};